import React, { useEffect, useState } from "react";
import CreateLeadForm from "./CreateLeadForm";
import NotesTab from "./NotesTab";
import RemindersTab from "./RemindersTab";
import { useLocation } from "react-router-dom";

function LeadManagementTabs({ toggleModal, fetchLeads }) {
  const [activeTab, setActiveTab] = useState("lead");
  const location = useLocation();
  const leadState = location.state?.leadId;
  // Tab configuration
  const tabs = [
    {
      id: "lead",
      label: "Lead Form",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
          />
        </svg>
      ),
    },
    {
      id: "notes",
      label: "Notes",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
          />
        </svg>
      ),
    },
    {
      id: "reminders",
      label: "Reminders",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      ),
    },
  ];

  useEffect(() => {
    if (leadState) {
      setActiveTab("reminders");
    }
  }, []);

  return (
    <div className="bg-white rounded-lg shadow-xl h-screen flex flex-col">
      {/* Header with Tabs Navigation - Fixed at top */}
      <div className="bg-white border-b border-gray-200 px-4 py-2 flex justify-between items-center z-[1000]">
        <nav className="flex space-x-1">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`px-4 py-2.5 rounded-lg flex items-center space-x-2 font-medium transition-colors duration-200 ${
                activeTab === tab.id
                  ? "bg-green-50 text-green-700 shadow-sm"
                  : "text-gray-600 hover:text-gray-900 hover:bg-gray-50"
              }`}
              onClick={() => setActiveTab(tab.id)}
              aria-current={activeTab === tab.id ? "page" : undefined}
            >
              <span
                className={`flex flex-col items-center justify-center sm:flex-row sm:space-x-2 ${
                  activeTab === tab.id ? "text-green-600" : "text-gray-500"
                }`}
              >
                {tab.icon}
                <span className="text-xs sm:text-sm mt-1 sm:mt-0">
                  {tab.label}
                </span>
              </span>

              {activeTab === tab.id && (
                <span className="hidden md:flex h-2 w-2 relative ml-1">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
                </span>
              )}
            </button>
          ))}
        </nav>

        <button
          onClick={toggleModal}
          className="rounded-full p-2 text-gray-500 hover:bg-gray-100 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-300 transition-colors duration-200"
          aria-label="Close"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>

      {/* Tab Content Container - Allows scrolling */}
      <div className="flex-grow overflow-hidden">
        {/* Each tab content is absolutely positioned to take the full space */}
        <div
          className={`h-full ${activeTab === "lead" ? "block" : "hidden"}`}
          style={{ height: "calc(100vh - 60px)" }} // Subtract header height
        >
          <CreateLeadForm toggleModal={toggleModal} fetchLeads={fetchLeads} />
        </div>

        <div
          className={`h-full overflow-auto ${
            activeTab === "notes" ? "block" : "hidden"
          }`}
          style={{ height: "calc(100vh - 60px)" }}
        >
          <NotesTab fetchLeads={fetchLeads} />
        </div>

        <div
          className={`h-full overflow-auto ${
            activeTab === "reminders" ? "block" : "hidden"
          }`}
          style={{ height: "calc(100vh - 60px)" }}
        >
          <RemindersTab fetchLeads={fetchLeads} />
        </div>
      </div>
    </div>
  );
}

export default LeadManagementTabs;
